"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("./constants"));
var svg_1 = require("./svg");
var ConsumerDisruptionBanner = function (_a) {
    var setIsOpen = _a.setIsOpen;
    return (react_1.default.createElement("div", { style: $container },
        react_1.default.createElement("div", { style: $leftGrouping },
            react_1.default.createElement("div", { style: $warning },
                react_1.default.createElement(svg_1.Warning, { backgroundColor: "#A15D24", height: 22, width: 22, borderColor: "none", strokeColor: "#fcf1d9" })),
            react_1.default.createElement("h1", { style: $text }, constants_1.default.COPY)),
        setIsOpen && (react_1.default.createElement("button", { onClick: function () { return setIsOpen(false); }, style: $close },
            react_1.default.createElement(svg_1.X, null)))));
};
exports.default = ConsumerDisruptionBanner;
var $container = {
    backgroundColor: '#fcf1d9',
    color: '#08031d',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'start',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
};
var $leftGrouping = {
    display: 'flex',
    flexDirection: 'row',
};
var $warning = {
    padding: 10,
};
var $text = {
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'left',
};
var $close = {
    margin: 10,
};
